import Head from "next/head";
import AboutHeader from "components/sections/AboutHeader";
import useScrollTop from "../../hooks/useScrollTop";
import Map from "components/sections/Map";
import MissionBanner from "components/sections/MissionBanner";

export default function about() {
  useScrollTop();

  return (
    <div className="wrapper">
      <Head>
        <title>About us – Apphud</title>
        <link rel="canonical" href="https://apphud.com/about" />
        <meta property="og:title" content="About us – Apphud" />
        <meta
          property="og:description"
          content="Who we are – meet the Apphud team."
        />
        <meta property="og:url" content="https://apphud.com/about" />
        <meta
          property="og:image"
          content="/images/og/im_2.webp"
          key="og:image"
        />
        <meta
          property="twitter:image"
          content="/images/og/im_2.webp"
          key="twitter:image"
        />
        <meta property="twitter:title" content="About us – Apphud" />
        <meta
          property="twitter:description"
          content="Who we are – meet the Apphud team."
        />
        <meta property="twitter:url" content="https://apphud.com/about" />
        <meta name="description" content="Who we are – meet the Apphud team." />
      </Head>

      <AboutHeader
        title={"Who we are"}
        text={
          "Denis, Alex, and Ren, who founded Apphud, have been collaborating since 2012 and have been involved in multiple startups in the Mobile, Crypto, and FoodTech sectors, achieving two successful exits."
        }
        additionalText={
          "In 2019, Apphud was conceived as the ultimate subscription tracking and analytics platform. Today, Apphud boasts a global remote team with an office in Delaware, dedicated to creating software utilized by thousands of app developers worldwide."
        }
      />
      <MissionBanner />
      <Map />
    </div>
  );
}
